'use client'
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import { postNotification } from 'bossjob-remote/dist/clientStorage'
import { DefaultAvatar } from 'images'
import { toggleMenu } from 'store/actions/navigationBar/toggleMenu'
import { getCurLanguage } from 'helpers/country'
import { Popover, Toast, Popup } from 'antd-mobile';
import { FacebookShareButton, TelegramShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton } from 'react-share'
import { Action } from 'antd-mobile/es/components/popover'
import { useSharedData } from 'bossjob-remote/dist/hooks'
import Text from 'components/Text'
import styled from '@emotion/styled';
import { Global, css } from '@emotion/react'
import { languages_h5 } from 'helpers/country.base'
import vip_user_icon_url from './vip_user_icon.png'
const langActions: Action[] = [
  { key: 'en-us', text: 'English' },
  { key: 'zh-cn', text: 'Chinese simplified' }
]

function replaceLanguageCode(url, languageCode) {
  const regex = /\/[a-zA-Z-]+\/(?=.+\/)/;
  return url.replace(regex, `/${languageCode}/`);
}

interface HamburgerProps {
  disabled?: boolean
  lang?: any
  userInfo?: any
  isLogin: boolean
}
const HamburgerH5 = ({ userInfo, isLogin }: HamburgerProps) => {
  const router = useRouter()
  const [openState, setOpenState] = useState(false)
  const [showPopupType, setShowPopupType] = useState('')

  useEffect(() => {
    postNotification('DISPATCH', toggleMenu(openState))
  }, [openState])
  const handleToGetStarted = () => {
    // @ts-ignore
    window?.gtag?.('event', 'sgh5_direction_login_event')
    sessionStorage.setItem('isChatRedirect', window.location.pathname) // 新用户注册之后要跳转到sg活动页面
    router.push(`/get-started?redirect=${window.location.pathname}`)
  }

  const { currentLangSlug } = getCurLanguage(languages_h5)
  const jobDetailUrl = typeof window !== "undefined" && window.location.href || ''
  const dic = useSharedData('DICTIONARY') || {}
  const shareModal = dic?.jobDetail?.shareModal ?? {}
  const langDicH5 = dic?.h5 || {}

  const handleChangeLang = (lang) => {
    const href = window.location.origin + replaceLanguageCode(window.location.pathname, lang)
    window.location.href = href
  }

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link)
    setTimeout(() => {
      Toast.show('Link copied success!')
    }, 500)
  }

  const handleShowPopupType = (popType) => {
    setTimeout(() => {
      setShowPopupType(popType)
    }, 200)
  }

  return (
    <>
      <Global styles={GlobalStyles} />
      <HamburgerH5Wrapper>

        <span className="share" onClick={() => {
          // @ts-ignore
          window?.gtag?.('event', 'sgh5_share_event')
          handleShowPopupType('share')
        }
        }>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M10.9082 2.65039L14.0002 2.65063V5.69895" stroke="#121212" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.8864 10.1368V12.7233C12.8864 13.1731 12.5217 13.5378 12.0719 13.5378H3.92681C3.47697 13.5378 3.1123 13.1731 3.1123 12.7233V4.57818C3.1123 4.12834 3.47697 3.76367 3.92681 3.76367H6.37033" stroke="#121212" strokeWidth="1.13333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.59961 8.04922L13.6996 2.94922" stroke="#121212" strokeWidth="1.13333" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>{langDicH5.share}</span>
        </span>

        <Popover.Menu
          actions={langActions}
          placement='bottom-start'
          onAction={node => {
            handleChangeLang(node.key)
          }}
          trigger='click'
        >
          <span className="lang">
            {currentLangSlug}
          </span>
        </Popover.Menu>

        <Popup
          visible={!!showPopupType}
          showCloseButton={false}
          onClose={() => {
            handleShowPopupType('')
          }}
          onMaskClick={() => {
            handleShowPopupType('')
          }}
          bodyStyle={{ borderRadius: '16px 16px 0px 0px', background: '#F6F6F6' }}
        >
          <div style={{ padding: '20px' }}>
            {
              showPopupType == 'share' ?
                <>
                  <div className="modal_share_list">
                    <div className="modal_share_item">
                      <WhatsappShareButton url={jobDetailUrl} className="modal_share_item_link">
                        <WhatsAppIcon />
                        <Text textStyle='sm'>{shareModal.whatsapp || "Whatsapp"}</Text>
                      </WhatsappShareButton>
                    </div>
                    <div className="modal_share_item">
                      <TelegramShareButton url={jobDetailUrl} className="modal_share_item_link">
                        <TelegramIcon />
                        <Text textStyle='sm'>{shareModal.telegram || "Telegram"}</Text>
                      </TelegramShareButton>
                    </div>
                    <div className="modal_share_item">
                      <FacebookShareButton url={jobDetailUrl} className="modal_share_item_link">
                        <FacebookIcon />
                        <Text textStyle='sm'>{shareModal.facebook || "Facebook"}</Text>
                      </FacebookShareButton>
                    </div>
                    <div className="modal_share_item">
                      <LinkedinShareButton url={jobDetailUrl} className="modal_share_item_link">
                        <LinkedinIcon />
                        <Text textStyle='sm'>
                          {shareModal.linkedin || "LinkedIn"}
                        </Text>
                      </LinkedinShareButton>
                    </div>
                    <div className="modal_share_item">
                      <TwitterShareButton url={jobDetailUrl} className="modal_share_item_link">
                        <TwitterIcon />
                        <Text textStyle='sm' textColor='warmgrey'>
                          {shareModal.twitter || "Twitter"}
                        </Text>
                      </TwitterShareButton>
                    </div>
                    <div className="modal_share_item">
                      <div
                        onClick={() => handleCopyLink(`${jobDetailUrl}`)}
                        className="modal_share_item_link"
                      >
                        <div className="copy_icon_bg">
                          <CopyLinkIcon />
                        </div>
                        <Text textStyle='sm'>{shareModal.copyLink || "Copy Link"}</Text>
                      </div>
                    </div>
                  </div>
                  <div className="cancel" onClick={() => { handleShowPopupType('') }}>{langDicH5.cancel}</div>
                </> : null
            }
          </div>
        </Popup>

        {!isLogin && (
          <div className="getStarted" onClick={handleToGetStarted} style={{ borderRadius: '38px' }}>
            {langDicH5.signin}
          </div>
        )}

        <div>
          {isLogin ? <div className="avatar_wrap">
            {isLogin && !openState ? (
              !userInfo?.vip?.is_vip ? (
                <img
                  src={userInfo?.avatar || DefaultAvatar}
                  className="profile_avatar"
                  alt='avatar'
                />
              ) : (
                <div className="vip_avatar">
                  <img
                    src={userInfo?.avatar || DefaultAvatar}
                    className="profile_avatar"
                    alt='avatar'
                  />
                  <img
                    src={vip_user_icon_url.src}
                    width={17}
                    height={7}
                    alt=''
                    style={{ position: 'absolute', bottom: '-2px', right: 0 }}
                  />
                </div>
              )
            ) : (
              <>
                <span />
                <span />
                <span />
              </>
            )}
          </div> : null}
        </div>
      </HamburgerH5Wrapper>
    </>
  )
}
const WhatsAppIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" fill="none">
  <rect y="0.0117188" width="50" height="50" rx="25" fill="#00D757" />
  <path d="M11.0057 39.0114L12.8985 32.0564C11.6513 29.9184 10.996 27.4868 11 25.0116C11 17.2795 17.2678 11.0117 24.9999 11.0117C32.7319 11.0117 39 17.2795 39 25.0116C39 32.7436 32.7323 39.0117 24.9999 39.0117C22.5258 39.0157 20.0953 38.3608 17.9581 37.1145L11.0057 39.0114ZM19.9474 18.4428C19.7667 18.454 19.59 18.5017 19.4281 18.5828C19.2763 18.6688 19.1376 18.7763 19.0165 18.902C18.8486 19.0602 18.7534 19.1974 18.651 19.3305C18.1335 20.0038 17.8552 20.8305 17.8601 21.6797C17.8629 22.3657 18.0421 23.0335 18.3221 23.6578C18.8947 24.9204 19.8369 26.2576 21.0813 27.4964C21.3811 27.7946 21.6737 28.0941 21.9888 28.3728C23.5335 29.7329 25.3743 30.7137 27.3647 31.2373L28.1613 31.3592C28.4203 31.3729 28.6794 31.3535 28.9397 31.341C29.3474 31.32 29.7455 31.2097 30.1058 31.0177C30.2894 30.9232 30.4679 30.8204 30.6421 30.7098C30.8159 30.599 30.7022 30.6707 30.8169 30.5836C31.006 30.4436 31.1219 30.3443 31.2789 30.1805C31.3951 30.0599 31.4959 29.9186 31.573 29.7576C31.6823 29.5293 31.7913 29.0939 31.8361 28.7315C31.8696 28.4543 31.8599 28.303 31.8555 28.2093C31.8499 28.0596 31.7252 27.9042 31.5896 27.8385L30.7749 27.4729C30.7749 27.4729 29.557 26.9423 28.8134 26.6037C28.7351 26.5696 28.6512 26.5501 28.5657 26.5461C28.4699 26.5364 28.3731 26.5472 28.2818 26.5779C28.1905 26.6086 28.1068 26.6584 28.0363 26.724V26.7212C28.0294 26.7212 27.9354 26.801 26.9234 28.0273C26.8047 28.1871 26.6008 28.2591 26.4081 28.2093C26.317 28.1849 26.2277 28.1539 26.1406 28.1169C25.9671 28.0439 25.907 28.0161 25.7879 27.9644L25.7807 27.9616C24.9798 27.6118 24.2383 27.1394 23.5828 26.5614C23.4064 26.4073 23.2426 26.2394 23.0747 26.0772C22.524 25.5497 22.044 24.953 21.6467 24.3021L21.564 24.169C21.5047 24.0796 21.4567 23.9832 21.4212 23.882C21.3679 23.6763 21.5067 23.5109 21.5067 23.5109C21.5067 23.5109 21.8469 23.1384 22.0051 22.9367C22.1366 22.7691 22.2597 22.595 22.3731 22.4146C22.5382 22.1486 22.5902 21.8755 22.5031 21.6641C22.1109 20.7062 21.7058 19.7537 21.2881 18.8068C21.2054 18.6191 20.9604 18.4848 20.738 18.4581C20.6626 18.4497 20.5867 18.4412 20.5113 18.4356C20.3233 18.4262 20.1351 18.4281 19.9471 18.4412V18.4428H19.9474Z" fill="white" />
</svg>

const TelegramIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" fill="none">
  <rect y="0.0117188" width="50" height="50" rx="25" fill="#00ABE5" />
  <path d="M24.7676 30.6952C24.8756 30.7689 24.9715 30.8288 25.0641 30.8956L29.9507 34.4938C31.1655 35.3899 31.952 35.0918 32.2638 33.62C33.0371 29.9715 33.811 26.3231 34.5854 22.6747C34.9932 20.7523 35.413 18.8333 35.8088 16.9091C35.9288 16.3334 36.0127 15.7217 35.497 15.2745C34.9813 14.8273 34.4518 15.0775 33.9275 15.2745L18.2738 21.3228C16.4816 22.0082 14.6877 22.7021 12.9023 23.4149C12.5116 23.5708 12.0576 23.7953 12.1039 24.3042C12.1467 24.7874 12.6179 24.909 13.012 25.0324C14.6534 25.5464 16.3 26.0604 17.9397 26.5744C18.0706 26.6227 18.2114 26.6377 18.3495 26.6183C18.4877 26.5989 18.6188 26.5455 18.7313 26.4631C22.1741 24.2859 25.6203 22.1156 29.07 19.9521C29.6971 19.558 30.3208 19.1588 30.9548 18.7767C31.1912 18.6328 31.4534 18.4923 31.7755 18.7853C31.6041 18.9566 31.4636 19.128 31.3009 19.2702C28.1174 22.1487 24.9321 25.0232 21.7452 27.8938C21.6308 27.9863 21.5387 28.1033 21.4755 28.2361C21.4123 28.3689 21.3798 28.5143 21.3802 28.6614C21.3614 29.3005 21.2946 29.9396 21.2517 30.5804C21.1798 31.629 21.1095 32.6776 21.0376 33.7416C21.483 33.781 21.7778 33.5703 22.0502 33.3115L24.7676 30.6952Z" fill="white" />
</svg>

const FacebookIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
  <rect y="0.0117188" width="50" height="50" rx="25" fill="#1196F5" />
  <path d="M30.2883 26.1881L30.9151 22.2707H27.1544V19.5285C27.1544 18.4316 27.5461 17.5698 29.2698 17.5698H31.0718V13.9657C30.0533 13.809 28.9564 13.6523 27.9378 13.6523C24.7255 13.6523 22.4534 15.6111 22.4534 19.1368V22.2707H18.9277V26.1881H22.4534V36.3735C24.0204 36.3735 25.5874 36.3735 27.1544 36.3735V26.1881H30.2883Z" fill="white" />
</svg>

const LinkedinIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
  <g clipPath="url(#clip0_24711_2938)">
    <path d="M0.333496 25.0117C0.333496 31.6421 2.96742 38.001 7.65583 42.6894C12.3442 47.3778 18.7031 50.0117 25.3335 50.0117C31.9639 50.0117 38.3228 47.3778 43.0112 42.6894C47.6996 38.001 50.3335 31.6421 50.3335 25.0117C50.3335 18.3813 47.6996 12.0225 43.0112 7.33405C38.3228 2.64564 31.9639 0.0117188 25.3335 0.0117188C18.7031 0.0117188 12.3442 2.64564 7.65583 7.33405C2.96742 12.0225 0.333496 18.3813 0.333496 25.0117Z" fill="#1368BD" />
    <path d="M17.6429 19.6555V37.7414H11.621V19.6555H17.6429ZM18.0272 14.0695C18.0431 14.4852 17.969 14.8993 17.8098 15.2836C17.6507 15.6679 17.4104 16.0133 17.1054 16.2961C16.4757 16.893 15.6522 17.1914 14.6304 17.1914H14.5929C13.5944 17.1914 12.7913 16.893 12.1851 16.2961C11.5757 15.6992 11.271 14.957 11.271 14.0695C11.271 13.1695 11.5835 12.4242 12.2101 11.8352C12.8351 11.2445 13.6538 10.9492 14.6647 10.9492C15.6757 10.9492 16.4851 11.2445 17.0929 11.8352C17.6991 12.4242 18.0101 13.1695 18.0226 14.0695H18.0272ZM39.3054 27.3742V37.7383H33.3022V28.0664C33.3022 26.7883 33.0554 25.7867 32.5632 25.0633C32.071 24.3383 31.3022 23.9773 30.2554 23.9773C29.4897 23.9773 28.8491 24.1867 28.3304 24.607C27.8147 25.0289 27.4272 25.5477 27.1726 26.1695C27.0382 26.532 26.971 27.0258 26.971 27.6461V37.7383H20.9679C20.9929 32.8836 21.0054 28.9477 21.0054 25.9305C21.0054 22.9117 20.9991 21.1102 20.9866 20.5273L20.9679 19.6508H26.971V22.2789H26.9335C27.1772 21.8883 27.4257 21.5492 27.6819 21.2555C27.9955 20.9085 28.3401 20.5911 28.7116 20.307C29.1871 19.9455 29.7261 19.6763 30.3007 19.5133C30.9797 19.3161 31.6843 19.2208 32.3913 19.2305C34.471 19.2305 36.1444 19.9211 37.4069 21.3023C38.6726 22.6836 39.3054 24.707 39.3069 27.3711L39.3054 27.3742Z" fill="white" />
  </g>
  <defs>
    <clipPath id="clip0_24711_2938">
      <rect width="50" height="50" fill="white" transform="translate(0.333496 0.0117188)" />
    </clipPath>
  </defs>
</svg>

const TwitterIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
  <rect x="0.666504" y="0.0117188" width="50" height="50" rx="25" fill="black" />
  <path d="M15.7355 15.7812H22.1074L26.6323 21.9426L32.1231 15.7812H34.13L27.5386 23.1761L35.6665 34.2428H29.2962L24.0453 27.0943L17.6734 34.2428H15.6665L23.1391 25.8609L15.7355 15.7812ZM18.8086 17.3197L30.1334 32.7043H32.5934L21.2686 17.3197H18.8086Z" fill="white" />
</svg>

const CopyLinkIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <path d="M12.9568 11.5784V11.5784C11.3947 10.0163 8.86209 10.0163 7.29999 11.5784L3.05735 15.8211C1.49525 17.3832 1.49525 19.9158 3.05735 21.4779V21.4779C4.61945 23.04 7.15211 23.04 8.7142 21.4779L12.9568 17.2353" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M11.1843 13.3513V13.3513C12.7464 14.9134 15.279 14.9134 16.8411 13.3513L21.0838 9.10862C22.6459 7.54652 22.6459 5.01386 21.0838 3.45177V3.45177C19.5217 1.88967 16.989 1.88967 15.4269 3.45177L11.1843 7.69441" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
</svg>

export default HamburgerH5

const GlobalStyles = css`
  html,
  body {
    .modal_share_list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 28px;
    }

    .modal_share_item {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .modal_share_item_link {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      text-decoration: none
    }

    .copy_icon_bg {
      display: flex;
      width: 50px;
      height: 50px;
      padding: 10px 9.882px 10px 10.118px;
      justify-content: center;
      align-items: center;
      border-radius: 38px;
      background: rgba(0, 0, 0, 0.10);
    }

    .cancel {
      display: flex;
      padding: 14px 0;
      margin: 20px 20px 0;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      background: #FFF;
      color: #000;
      font-size: 15px;
    }
  }
`
const HamburgerH5Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .getStarted {
    line-height: 1;
    padding: 8px 20px;
    /* border: 1px solid #579bf5; */
    text-align: center;
    font-size: 14px;
    color: #2378e5;
    &:hover,
    &:active,
    &:focus {
      background: #2378e5;
      color: #fff;
    }
    border-radius: 38px;
  }

  .avatar_wrap {
    display: flex;
    justify-content: center;
    width: 32px;
    height: 32px;
    line-height: 1;
  }

  .profile_avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .vip_avatar {
    position: relative;
    border: 2px solid #ffc248;
    border-radius: 50%;
    box-sizing: border-box;
    img {
      border-radius: 50%;
    }
  }

  .share {
    display: flex;
    width: 79px;
    height: 32px;
    line-height: 1;
    margin-right: 16px;
    justify-content: center;
    align-items: center;
    border-radius: 38px;
    font-size: 14px;
    color: #121212;
    background: #f6f6f6;
    span {
      display: inline-block;
      margin-left: 2px;
    }
  }

  .lang {
    display: flex;
    line-height: 1;
    width: 32px;
    height: 32px;
    margin-right: 16px;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
    font-size: 14px;
    color: #121212;
    background: #f6f6f6;
  }
`
